// @ts-nocheck
import { CountryModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";
import getPostalCodeConstantsKey from "@store/Framework/Common/Utilities/getPostalCodeConstantsKey";

const getPostalCodeConstants = (country: CountryModel | null | undefined | string) => {
    return constants.formField[getPostalCodeConstantsKey(country)];
};

export default getPostalCodeConstants;
